module.exports = __webpack_public_path__ + "static/fonts/Roboto.69eee0b.woff2";